<template>
  <v-tooltip
    bottom
    content-class="text-base shadow-sm speech-bubble text--secondary opacity-1 rounded-lg"
    color="white"
    max-width="200"
    :disabled="disabledTooltip"
  >
    <template #activator="{ on, attrs }">
      <div
        class="timeline__item"
        :class="`${status} ${status != 'lock' ? 'pointer-on-hover' : ''}`"
        v-bind="attrs"
        style="height: 300px;"
        @click="$emit('click')"
        v-on="on"
      >
        <p
          v-show="titleOnTop"
          class="font-weight-bold"
          :class="`text-${textColor}`"
        >
          {{ title }}
        </p>
        <div
          :data-icon="`#icon-${icon}`"
          class="timeline__icon mb-2 bg-white"
        >
          <svg xmlns="http://www.w3.org/2000/svg">
            <use :xlink:href="`#icon-${icon}`" />
          </svg>
        </div>
        <p
          v-show="!titleOnTop"
          class="timeline__text mb-0"
          :class="`text-${textColor}`"
        >
          {{ title }}
        </p>
        <div
          class="text-subtitle-1 text-center"
          style="height: 60px; width: 120px;"
        >
          <span
            v-show="!hideSubtitle"
          >{{ subtitle }}</span>
        </div>
      </div>
    </template>
    <slot />
  </v-tooltip>
</template>

<script>
export default {
  props: {
    icon:{
      required: true,
      type: String,
      validator: function(value) {
        return ['lock','finished','current','planet'].includes(value)
      }
    },
    status: {
      default:'normal',
      required:false,
      validator: function(value){
        return ['lock','selected','normal'].includes(value)
      }
    },
    title: {
      type: String,
      required: true,
    },
    titleOnTop: {
      type: Boolean,
      required: false,
      default: false,
    },
    hideSubtitle:{
      type:Boolean,
      default: false,
      required:false,
    },
    subtitle: {
      type: String,
      default: '',
      required: false,
    },
    textColor: {
      type:String,
      default: '',
      required: false,
    },
    disabledTooltip: {
      type: Boolean,
      default: true,
      required: false,
    },
  },
}
</script>
<style scoped>
.v-tooltip__content {
  top: 810px !important;
}
</style>

